<div class="ai-field">
    @if (label() && (required() || forceRequired())) {
        <label>
            {{ label() }}
            <span>
                <ai-icon
                    class="label-required"
                    [fontIcon]="'red_rectangle_icon'"
                />
            </span>
        </label>
    } @else if (label()) {
        <label>{{ label() }}</label>
    }

    <ng-content></ng-content>

    <ai-control-errors [control]="control()" [messages]="errorMessages()" />
</div>
